export class LandingController {
  constructor($scope, $cookies, $http, $modal, AuthService, toastr, RegionService, CityService, SliderService, UserService, $rootScope, $route, $location, $anchorScroll, $window) {
    $scope.vm = this;
    this.scope = $scope;
    this.http = $http;
    this.cookies = $cookies;
    this.modal = $modal;
    this.toastr = toastr;
    this.anchorScroll = $anchorScroll;
    this.AuthService = AuthService;
    this.UserService = UserService;
    this.RegionService = RegionService;
    this.CityService = CityService;
    this.SliderService = SliderService;
    this.rootScope = $rootScope;
    this.route = $route;
    this.location = $location;
    this.window = $window

    this.init();
  }

  init() {
    this.scope.regStep = 1;
    this.scope.loginform_show = true;
    this.scope.years = [];
    this.scope.regions = [];
    this.scope.allCities = [];
    this.scope.cities = [];
    this.scope.currUser = {};
    this.scope.user = {};
    this.scope.params = {};
    this.scope.params.filters = {};

    if(this.cookies.get('remember')) {
      this.scope.user.remember = true;
    }

    //init slider
    this.SliderService.getPhotos()
      .then((response) => { let data = response.data;
        this.scope.photosForSliderLoaded = false;
        this.scope.photosForSlider = [];

        if(data.data.length < 10) {
          for(var i = 0; i < 27; i++) {
            this.scope.photosForSlider.push('/images/slider/users/' + (i + 1) + '.jpg');
          }
        } else {
          this.scope.photosForSlider = data.data;
        }

        this.scope.photosForSliderLoaded = true;
      });

    this.RegionService.getRegionsList()
      .then((response) => { let regions = response.data;
        this.scope.regions = regions.data;
      });

    this.CityService.getCitiesList()
      .then((response) => { let cities = response.data;
        this.scope.allCities = cities.data;
      });

    //On change region
    this.scope.changeRegion = () => {
      let region = this.scope.params.filters.region;
      this.scope.cities = _.filter(this.scope.allCities, item => item.region === region._id);
    };

    for (var i = new Date().getYear() - 100; i < new Date().getYear() - 17; i++) {
      this.scope.years.push(i + 1900);
    }

    this.scope.changeDate = () => {
      this.scope.daysInMonth = [];
      var days = 31;

      if(this.scope.currUser.birth) {
        if(this.scope.currUser.birth.month == 4 ||
          this.scope.currUser.birth.month == 6 ||
          this.scope.currUser.birth.month == 9 ||
          this.scope.currUser.birth.month == 11)
        {
          days = 30;
        }

        if(this.scope.currUser.birth.month == 2) {
          if(this.scope.currUser.birth.year) {
            if(this.scope.currUser.birth.year%4 == 0) {
              days = 29;
            } else {
              days = 28;
            }
          } else {
            days = 28;
          }
        }
      }

      for (var i = 1; i <= days; i++) {
        this.scope.daysInMonth.push(i);
      }
    };

    this.scope.changeDate();

    this.scope.recoverPassword = (mail) =>{
      this.UserService.recoverPassword({email: mail})
        .then((response) => {

          this.toastr.success('Por favor, verifica tu correo electrónico, te hemos enviado la información de tu cuenta.');
        })

        .catch((response) => { let error = response.data;
          console.log(error);
          this.toastr.error('Tu correo electrónico no se encuentra registrado en el sitio.');
        });
    };

    this.scope.recoverModalOpen = () => {
      let modalInstance = this.modal.open({
        templateUrl: '../../views/recover-modal.html',
        controller: 'RecoverPassController',
        windowClass: "reveal-modal tiny open"
      });

      modalInstance.result.then(this.scope.recoverPassword).catch(angular.noop);
    };

    this.scope.rulesModalOpen = () => {
      this.modal.open({
        templateUrl: '../../views/rules-modal.html',
        controller: 'RulesModalController'
      }).result.catch(angular.noop);
    };

    this.scope.getCurrentYear = () => {
      return new Date().getFullYear();
    };

    this.scope.anchorScroll = (hash) => {
      if (this.location.hash() !== hash) {
        this.location.hash(hash);
      } else {
        this.anchorScroll();
      }
    };
  }

  login() {
    if(this.scope.user.remember) {
      this.cookies.put('remember', true, {expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)});
    }
    else {
      this.cookies.put('remember', false, {expires: new Date(0)});
    }

    this.AuthService.login(this.scope.user.username, this.scope.user.password, this.scope.user.remember);
  }

  firstFormValid(form) {
    if (form.$valid) {
      this.scope.regStep = 2;
    } else {
      // this.scope.submittedForm1 = true;
      this.toastr.warning('Rellene todos los campos del registro');
    }
  }

  registerUser(register_form_2, params) {
    if (!register_form_2.$valid) {
      this.scope.submittedForm2 = true;
      this.toastr.warning('Rellene todos los campos del registro');
      return;
    }

    if(!params.terms){
      this.toastr.warning('Acepto Condiciones de uso');
      return;
    }

    params.birthday = new Date(this.scope.currUser.birth.year, this.scope.currUser.birth.month - 1, this.scope.currUser.birth.day, 0, 0, 0);

    var day = this.scope.currUser.birth.day;
    var month = this.scope.currUser.birth.month;

    function getZodiac()
    {
      var zodiac = '';
      var zodSings = ["Capricornio", "Aquarius", "Piscis", "Aries",
        "Taurus", "Gemini", "cáncer", "Leo", "virgo", "Libra", "Escorpión",
        "Sagitario"];
      switch (month)
      {
        case '01':
          if (day < 20)
            zodiac = zodSings[0];
          else
            zodiac = zodSings[1];
          break;
        case '02':
          if(day < 19)
            zodiac = zodSings[1];
          else
            zodiac = zodSings[2];
          break;
        case '03':
          if(day < 20)
            zodiac = zodSings[2];
          else
            zodiac = zodSings[3];
          break;
        case '04':
          if(day < 21)
            zodiac = zodSings[3];
          else
            zodiac = zodSings[4];
          break;
        case '05':
          if(day < 21)
            zodiac = zodSings[4];
          else
            zodiac = zodSings[5];
          break;
        case '06':
          if(day < 23)
            zodiac = zodSings[5];
          else
            zodiac = zodSings[6];
          break;
        case '07':
          if(day < 23)
            zodiac = zodSings[6];
          else
            zodiac = zodSings[7];
          break;
        case '08':
          if(day < 23)
            zodiac = zodSings[7];
          else
            zodiac = zodSings[8];
          break;
        case '09':
          if(day < 23)
            zodiac = zodSings[8];
          else
            zodiac = zodSings[9];
          break;
        case '10':
          if(day < 23)
            zodiac = zodSings[9];
          else
            zodiac = zodSings[10];
          break;
        case '11':
          if(day < 22)
            zodiac = zodSings[10];
          else
            zodiac = zodSings[11];
          break;
        case '12':
          if(day < 22)
            zodiac = zodSings[11];
          else
            zodiac = zodSings[0];
           break;
      }
      return zodiac;
   }

    function calculate_age(birth_month, birth_day, birth_year) {
      var difDate = new Date(new Date() - new Date(birth_year, birth_month, birth_day));
      return difDate.getUTCFullYear() - 1970;
    }

    switch (params.filter_age) {
      case '1':
        params.filters.minage = 18;
        params.filters.maxage = 24;
        break;
      case '2':
        params.filters.minage = 25;
        params.filters.maxage = 31;
        break;
      case '3':
        params.filters.minage = 32;
        params.filters.maxage = 38;
        break;
      case '4':
        params.filters.minage = 39;
        params.filters.maxage = 45;
        break;
      case '5':
        params.filters.minage = 46;
        params.filters.maxage = 52;
        break;
      case '6':
        params.filters.minage = 53;
        params.filters.maxage = 100;
        break;
      default:
        break;
    }
    params.photoprofile = {};
    params.region = params.filters.region;
    params.socialinfo.zodiacsign = getZodiac();
    params.age = calculate_age(this.scope.currUser.birth.month - 1, this.scope.currUser.birth.day, this.scope.currUser.birth.year);

    if(params.age < 18) {
      this.toastr.info('Debes ser mayor de 18 años');
      return;
    }

    params.photoprofile.url = '';

    var user = angular.copy(params);
    delete user['filter_age'];

    this.UserService.signIn(user)
      .then((_res) => { let response = _res.data;
        if (response.success) {
          this.toastr.info('¡Gracias por registrarte!');
          this.window.ga('send', 'event', 'Sign up', 'Finalize button', 'New profile');
          window.google_trackConversion({
            google_conversion_id: 1049493181,
            google_conversion_language: "es",
            google_conversion_format: "1",
            google_conversion_color: "941164",
            google_conversion_label: "quGmCNP3jQEQvf239AM",
            google_conversion_value: 1.00,
            google_conversion_currency: "CLP",
            google_remarketing_only: false,
            onload_callback: () => {
              this.window.ga('send', 'event', 'Sign up', 'Finalize button', 'New profile',{
                hitCallback: () => {
                  this.AuthService.login(user.username, user.password, true);
                },
                hitCallbackFail: () =>{
                  this.AuthService.login(user.username, user.password, true);
                }
              });

            }
          });
        }
        else {
          if(response.message === 'Email already exists') {
            this.toastr.warning('Este correo electrónico ya está siendo utilizado por otro perfil, por favor usa uno diferente');
          } else if(response.message) {
            this.toastr.warning('Este nombre de usuario ya esta siendo ocupado por otro perfil, por favor escoge uno diferente');
          } else {
            this.toastr.error('Registro de error');
          }
        }
      })

      .catch((response) => { let error = response.data;
        console.log(error);
        this.toastr.error('Registro de error');
      });
  }
}
